import PropTypes from 'prop-types'
import React from 'react'

import DefaultTooltip from 'components/DefaultTooltip/DefaultTooltip'

import { INDUSTRIAL_RESOURCE_MULTIPLIER_TOOLTIP_TEXT } from './constants'

export const IndustrialResourceCoefTooltip = ({ multiplier }) => {
    return (
        <DefaultTooltip
            id={IndustrialResourceCoefTooltip.id}
            message={INDUSTRIAL_RESOURCE_MULTIPLIER_TOOLTIP_TEXT(multiplier)}
        />
    )
}

IndustrialResourceCoefTooltip.id = 'industrial_resource_multiplier_tooltip'

IndustrialResourceCoefTooltip.propTypes = {
    multiplier: PropTypes.number.isRequired,
}

export default IndustrialResourceCoefTooltip



// WEBPACK FOOTER //
// ./components/IndustrialResourceCoefTooltip/IndustrialResourceCoefTooltip.jsx